import "./createCampaignTopNav.scss";
import Button, {
  ButtonTypes,
} from "../../../../../common/components/button/button";
import TextField from "../../../../../common/components/inputFields/textFields/textField";
import { ReactComponent as StyleIcon } from "../../../../../assets/styleIcon.svg";
import { ReactComponent as ShareIcon } from "../../../../../assets/shareIcon.svg";
import { useEffect, useState } from "react";
import { LoadingStatus } from "../../../../../common/enums/loadingStatus";

export default function CreateCampaignTopNav(props: {
  index?: number;
  username?: string;
  title?: string;
  description?: string;
  onTitleChange?: (e: string) => void;
  onDescriptionChange?: (e: string) => void;
  onClickStyle?: () => void;
  onClickShare?: () => void;
  onClickSave?: () => void;
  saveButtonLoadingStatus?: LoadingStatus;
}) {
  const [title, setTitle] = useState<string>(
    props.title ?? "Untitled Campaign"
  );
  const [description, setDescription] = useState<string>(
    props.description ?? "Description"
  );

  useEffect(() => {
    if (props.title) setTitle(props.title);
    if (props.description) setDescription(props.description);
  }, [props.title, props.description]);

  return (
    <div className="create-campaign-top-nav">
      <div className="title-container">
        <TextField
          initialValue={title}
          fontSize="24px"
          padding="2px"
          hideBorder
          onChange={(e) => {
            setTitle(e);
            props.onTitleChange?.(e);
          }}
        />
        <TextField
          initialValue={description}
          padding="2px"
          hideBorder
          maxWidth={"200px"}
          onChange={(e) => {
            setDescription(e);
            props.onDescriptionChange?.(e);
          }}
        />
      </div>
      <div className="actions-container">
        <StyleIcon
          height={20}
          width={20}
          style={{ cursor: "pointer" }}
          onClick={props.onClickStyle}
        />
        <ShareIcon
          height={20}
          width={20}
          style={{ cursor: "pointer" }}
          onClick={props.onClickShare}
        />
        <Button
          type={ButtonTypes.PRIMARY}
          text={"Save"}
          onClick={props.onClickSave}
          loadingStatus={props.saveButtonLoadingStatus}
        />
      </div>
    </div>
  );
}
